import ROUTER from '@/routes/ROUTER'
import React from 'react'
import { LazyLoadingComponent } from '..'
const ChangeInfomationHistory = React.lazy(
  () => import('@/pages/USER/MyAccount/components/ChangeInfomationHistory')
)
const MyAccount = React.lazy(() => import('@/pages/USER/MyAccount'))
const MyContracts = React.lazy(() => import('@/pages/USER/HopDong'))
const MyCertificates = React.lazy(() => import('@/pages/USER/BangCapChungChi'))
const LeaveDetail = React.lazy(() => import('@/pages/ADMIN/LeaveList/LeaveDetail'))
const ViolationDetail = React.lazy(() => import('@/pages/ADMIN/ViolationDetail'))
const TimesheetPage = React.lazy(() => import('@/pages/ADMIN/Timesheet'))
const PersonalOverviewPage = React.lazy(() => import('@/pages/USER/PersonalOverview'))
const PersonalWorkingCalendarPage = React.lazy(() => import('@/pages/USER/PersonalWorkingCalendar'))

export const userRoutes = [
  {
    path: ROUTER.LICH_SU_CAP_NHAT_THONG_TIN,
    element: (
      <LazyLoadingComponent>
        <ChangeInfomationHistory />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.TONG_QUAN_CUA_TOI,
    element: (
      <LazyLoadingComponent>
        <PersonalOverviewPage />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.THONG_TIN_TAI_KHOAN,
    element: (
      <LazyLoadingComponent>
        <MyAccount />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.HOP_DONG_CUA_TOI,
    element: (
      <LazyLoadingComponent>
        <MyContracts />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.BANG_CAP_CHUNG_CHI,
    element: (
      <LazyLoadingComponent>
        <MyCertificates />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.LICH_LAM_VIEC_CUA_TOI,
    element: (
      <LazyLoadingComponent>
        <PersonalWorkingCalendarPage />
      </LazyLoadingComponent>
    ),
  },
  // {
  //   path: ROUTER.DANH_SACH_PHIEU,
  //   element: (
  //     <LazyLoadingComponent>
  //       <LeaveRequest />
  //     </LazyLoadingComponent>
  //   ),
  // },
  {
    path: ROUTER.CHI_TIET_NGHI_PHEP_CUA_TOI,
    element: (
      <LazyLoadingComponent>
        <LeaveDetail />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.VI_PHAM_CUA_TOI,
    element: (
      <LazyLoadingComponent>
        <ViolationDetail />
      </LazyLoadingComponent>
    ),
  },
  {
    path: ROUTER.BANG_CONG,
    element: (
      <LazyLoadingComponent>
        <TimesheetPage />
      </LazyLoadingComponent>
    ),
  },
]
